import { useState } from 'react';
import { TwoFactorMethodSelection } from './two-factor-method-selection';
import { EmailOTPVerification } from './email-otp-verification';
import { AuthenticatorSetup } from './authenticator-setup';
import { SMSVerification } from './sms-verification';
import { Disable2FAModal } from './disable-2fa-modal';

export { Disable2FAModal };

interface TwoFactorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  userEmail: string;
}

export type TwoFactorMethod = 'totp' | 'whatsapp' | 'email' | null;

export const TwoFactorModal = ({
  isOpen,
  onClose,
  onSuccess,
  userEmail,
}: TwoFactorModalProps) => {
  const [currentStep, setCurrentStep] = useState<
    'method-selection' | 'verification'
  >('method-selection');
  const [selectedMethod, setSelectedMethod] = useState<TwoFactorMethod>(null);

  const handleMethodSelect = (method: TwoFactorMethod) => {
    setSelectedMethod(method);
    setCurrentStep('verification');
  };

  const handleBack = () => {
    setCurrentStep('method-selection');
    setSelectedMethod(null);
  };

  const handleSuccess = () => {
    setCurrentStep('method-selection');
    setSelectedMethod(null);
    onSuccess?.();
    onClose();
  };

  const handleClose = () => {
    setCurrentStep('method-selection');
    setSelectedMethod(null);
    onClose();
  };

  return (
    <>
      <TwoFactorMethodSelection
        isOpen={isOpen && currentStep === 'method-selection'}
        onClose={handleClose}
        onMethodSelect={handleMethodSelect}
      />

      {selectedMethod === 'email' && (
        <EmailOTPVerification
          isOpen={currentStep === 'verification'}
          onClose={handleClose}
          onBack={handleBack}
          onSuccess={handleSuccess}
          email={userEmail}
        />
      )}

      {selectedMethod === 'totp' && (
        <AuthenticatorSetup
          isOpen={currentStep === 'verification'}
          onClose={handleClose}
          onBack={handleBack}
          onSuccess={handleSuccess}
        />
      )}

      {selectedMethod === 'whatsapp' && (
        <SMSVerification
          isOpen={currentStep === 'verification'}
          onClose={handleClose}
          onBack={handleBack}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
};
